import React from 'react';

const Contact = ({ data }) => {
   const [formData, setFormData] = React.useState({
      contactName: '',
      contactEmail: '',
      contactSubject: '',
      contactMessage: ''
   });
   const [status, setStatus] = React.useState('');

   if (!data) return null;

   const { name, image, address, phone, email, resumedownload } = data;
   const { city, state, zip } = address;

   const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData(prev => ({ ...prev, [name]: value }));
   };

   const sendEmail = (e) => {
      e.preventDefault();
      setStatus('sending');

      const formDataObj = new FormData();
      formDataObj.append('name', formData.contactName);
      formDataObj.append('email', formData.contactEmail);
      formDataObj.append('subject', formData.contactSubject);
      formDataObj.append('message', formData.contactMessage);

      fetch('https://formspree.io/f/mjggbagy', {
         method: 'POST',
         body: formDataObj,
         headers: {
            'Accept': 'application/json'
         }
      })
         .then(response => {
            if (response.ok) {
               setStatus('success');
               setFormData({ contactName: '', contactEmail: '', contactSubject: '', contactMessage: '' });
               alert('Message sent successfully!');
            } else {
               response.json().then(data => {
                  if (Object.hasOwn(data, 'errors')) {
                     setStatus('error');
                     alert(data["errors"].map(error => error["message"]).join(", "));
                  } else {
                     setStatus('error');
                     alert('Failed to send message. Please try again.');
                  }
               });
            }
         })
         .catch(error => {
            setStatus('error');
            console.error('Formspree Error:', error);
            alert('Failed to send message. Please check your internet connection.');
         });
   };

   return (
      <section id="contact">
         <div className="row section-head">
            <div className="two columns header-col">
               <h1><span>Get In Touch.</span></h1>
            </div>
            <div className="ten columns">
               <p className="lead">{data.contactmessage}</p>
            </div>
         </div>

         <div className="row">
            <div className="eight columns">
               <form id="contactForm" name="contactForm" onSubmit={sendEmail}>
                  <fieldset>
                     <div>
                        <label htmlFor="contactName">Name <span className="required">*</span></label>
                        <input
                           type="text"
                           value={formData.contactName}
                           size="35"
                           id="contactName"
                           name="contactName"
                           onChange={handleChange}
                           required
                        />
                     </div>

                     <div>
                        <label htmlFor="contactEmail">Email <span className="required">*</span></label>
                        <input
                           type="email"
                           value={formData.contactEmail}
                           size="35"
                           id="contactEmail"
                           name="contactEmail"
                           onChange={handleChange}
                           required
                        />
                     </div>

                     <div>
                        <label htmlFor="contactSubject">Subject</label>
                        <input
                           type="text"
                           value={formData.contactSubject}
                           size="35"
                           id="contactSubject"
                           name="contactSubject"
                           onChange={handleChange}
                        />
                     </div>

                     <div>
                        <label htmlFor="contactMessage">Message <span className="required">*</span></label>
                        <textarea
                           cols="50"
                           rows="15"
                           value={formData.contactMessage}
                           id="contactMessage"
                           name="contactMessage"
                           onChange={handleChange}
                           required
                        ></textarea>
                     </div>

                     <div>
                        <button className="submit" disabled={status === 'sending'}>
                           {status === 'sending' ? 'Sending...' : 'Submit'}
                        </button>
                        <span id="image-loader" style={{ display: status === 'sending' ? 'inline-block' : 'none' }}>
                           <img alt="" src="images/loader.gif" />
                        </span>
                     </div>
                  </fieldset>
               </form>

               <div id="message-warning"> Error sending message.</div>
               <div id="message-success" style={{ display: status === 'success' ? 'block' : 'none' }}>
                  <i className="fa fa-check"></i>Your message was sent, thank you!<br />
               </div>
            </div>

            <aside className="four columns footer-widgets">
               <div className="widget widget_contact">
                  <h4>Address and Phone</h4>
                  <p className="address">
                     {name}<br />
                     {city}, {state} {zip}<br />
                     <span>{phone}</span><br />
                     <span>{email}</span>
                  </p>
               </div>
            </aside>
         </div>
      </section>
   );
};

export default Contact;
